/*
 * Author: Dw
 * File Created: Thursday, 24-09-05 10:26 am
 * Last Modified: Wednesday, 25-04-09 01:48 pm, by Harper Yan
 */

import getConfig from 'next/config';

import { basePath } from '@/constants';

const { publicRuntimeConfig } = getConfig();

export const staticPrefix = (path: string) => {
  // 如果 path 以 "/" 开头，移除它
  const cleanedPath = path.startsWith('/') ? path.slice(1) : path;

  return `${publicRuntimeConfig.STATIC_HOST}/${cleanedPath}`;
};

export const staticImgPrefix = (path: string) => {
  const cleanedPath = path.startsWith('/') ? path.slice(1) : path;

  return staticPrefix(`images/${cleanedPath}`);
};

export const proxyImg = (url: string) => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${basePath}/api/img?url=${encodeURIComponent(url)}`;
  }

  return '';
};
